import React from 'react';
export function FarmingtonFAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-1281">
      Frequently Asked Questions
    </h2>;
}